import { render } from "./TheProfessionalPatientPersonalDataModal.vue?vue&type=template&id=6da66933&ts=true"
import script from "./TheProfessionalPatientPersonalDataModal.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalPatientPersonalDataModal.vue?vue&type=script&lang=ts"

import "./TheProfessionalPatientPersonalDataModal.vue?vue&type=style&index=0&id=6da66933&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__